import script from "./Visa.vue?vue&type=script&setup=true&lang=js"
export * from "./Visa.vue?vue&type=script&setup=true&lang=js"

import "./Visa.vue?vue&type=style&index=0&id=2fbdb837&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fbdb837"]])

export default __exports__